import { Spezifikation } from '../../mdqx-graphql-types';
export class SpezifikationEntity {
    public static readonly GqlFields = 'id name';

    public Id: number;
    public Name: string;

    constructor(spezifikationType: Spezifikation | null) {
        if (
            spezifikationType &&
            spezifikationType.id != null &&
            spezifikationType.name != null
        ) {
            this.Id = spezifikationType.id;
            this.Name = spezifikationType.name;
        } else {
            console.error('received broken SpezifikationType', spezifikationType);
            throw Error();
        }
    }
}
